import { Info } from '@mui/icons-material';
import { Button, Chip, FormControlLabel, Stack, Switch } from '@mui/material';
import { CouponListingType } from 'containers/coupons/CouponListingType';
import React, { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import usePortalId from 'hooks/portal/usePortalId';
import { ROOT_NAVIGATION } from 'routes/paths';
import PartialPageSpinner from 'components/PartialPageSpinner';

type Props = {
  allowCoupon: boolean;
  allowDonation: boolean;
  data: CouponListingType[];
  onChangeMode: (e: React.ChangeEvent<HTMLInputElement>) => void;
  changeKeyValue: (name: string, value: boolean) => void;
  isLoading: boolean;
};

const CouponSettingsForm: FunctionComponent<Props> = ({
  allowCoupon,
  onChangeMode,
  data,
  allowDonation,
  changeKeyValue,
  isLoading,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const portalId = usePortalId();
  useEffect(() => {
    if (allowDonation) {
      changeKeyValue('allowCoupon', false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowDonation]);

  const goToCreateCoupon = () => {
    navigate(ROOT_NAVIGATION.general.couponsCreate(portalId));
  };

  const currentTimeStamp = Date.now();

  return (
    <Stack direction='column' spacing='20px'>
      {!isLoading ? (
        <div>
          <FormControlLabel
            control={
              <Switch
                name='allowCoupon'
                checked={allowDonation ? false : allowCoupon}
                onChange={onChangeMode}
                disabled={allowDonation}
              />
            }
            label={t('allow_coupons')}
          />
          {allowCoupon && data.length > 0 && (
            <div className='flex items-center text-[14px] text-gray-600'>
              <Info sx={{ width: '15px', height: '15px' }} />{' '}
              <span className='ml-1' style={{ width: '50%' }}>
                {' '}
                {t('applied_coupons_are')}
              </span>
            </div>
          )}
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {allowCoupon &&
              !allowDonation &&
              data.length > 0 &&
              data.map((item: CouponListingType) => {
                if (
                  item.expire_date === 'never_expired' ||
                  //@ts-ignore
                  Number(item.expire_date.$date.$numberLong) > currentTimeStamp
                ) {
                  return (
                    <Chip
                      key={item.coupon_code}
                      variant='outlined'
                      label={item.coupon_code}
                      sx={{ width: 150, margin: '7px' }}
                    />
                  );
                }
              })}
            {allowCoupon && !allowDonation && data.length > 0 && (
              <Button onClick={goToCreateCoupon}>Click to create Coupon</Button>
            )}
            {allowCoupon && data.length === 0 && (
              <p>No Coupons are Available</p>
            )}
            {allowDonation && (
              <div className='flex items-center text-[14px] text-gray-600'>
                <Info sx={{ width: '15px', height: '15px' }} />{' '}
                <span className='ml-1' style={{ width: '100%' }}>
                  {' '}
                  {t('if_donation_is_allowed_then')}
                </span>
              </div>
            )}
          </div>
        </div>
      ) : (
        <PartialPageSpinner />
      )}
    </Stack>
  );
};

export default React.memo(CouponSettingsForm);
